import { render, staticRenderFns } from "./SfBanner.vue?vue&type=template&id=21cf9144&"
import script from "./SfBanner.vue?vue&type=script&lang=js&"
export * from "./SfBanner.vue?vue&type=script&lang=js&"
import style0 from "./SfBanner.vue?vue&type=style&index=0&id=21cf9144&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports